export default {
  'staticqr.invalide.account': 'Invalide account',
  'staticqr.loading': 'Loading...',
  'staticqr.amount': 'Payment Amount',
  'staticqr.amount.placeholder': 'input amount',
  'staticqr.rate': 'Fx rate',
  'staticqr.fee.wechat': 'Merchant service fee',
  'staticqr.fee': 'Merchant service fee',
  'staticqr.total': 'Total',
  'staticqr.reference.placeholder': 'Note(optional)',
  'staticqr.reference.placeholder.required': 'Note',
  'staticqr.error.api': 'Service unavailable',
  'staticqr.error.api.transaction': 'Transaction unavailable',

  'staticqr.wechatpay': 'Wechat Pay',
  'staticqr.alipay': 'Alipay',

  'staticqr.number': 'Please enter a number.',
  'staticqr.minimum': 'The minimum number is 0.01.',
  'staticqr.maxmum': 'The maxmum number is 1 million.',

  'confirm.method': 'Payment Method',
  'confirm.created': 'Created On',
  'confirm.transaction.id': 'Transaction ID',

  'confirm.successful': 'Payment Successful',
  'confirm.unpaid': 'Payment unpaid',
  'confirm.tips': 'Please take a screenshot and send to merchant',

  'confirm.notfound': 'Payment Not Found',

  'confirm.invalid': 'Payment Invalid',

  'staticqr.reftoolong': 'Reference too long',
  'error.back.merchant': 'Go Back to Merchant',
  'error.title': 'Error',
  'staticqr.need_reference': 'Need Reference',
  'staticqr.reference.placeholder.code': 'Please input code',
  'staticqr.reference.placeholder.invoice': 'Please input invoice number'
};



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js